// Left menu
export const LEFT_MENU_USER_MANAGEMENT = "User Management";
export const LEFT_MENU_ROLE_AND_PERMISSION = "Role and Permission";
export const LEFT_MENU_ADMINISTRATION = "Administration";
export const LEFT_MENU_MANAGE_RESOURCE = "Manage Resource";
export const LEFT_MENU_MANAGE_PACKAGE = "Manage Package";
export const LEFT_MENU_MANAGE_PRODUCT = "Manage Product";
export const LEFT_MENU_MANAGE_INDUSTRY = "Home Page";

// Error messages
export const ERROR_INPUT_REQUIRED = "Input required";
export const ERROR_EMAIL_IS_INVALID = "Invalid Email";
export const ERROR_PASSWORD_NOT_MATCH = "Password is not matched";
export const ERROR_PERMISSION_NOT_CHOICE = "Please select permission!";

export const EDIT_MODEL_CREATE = "CREATE";
export const EDIT_MODEL_EDIT = "EDIT";
export const EDIT_MODEL_VIEW = "VIEW";

//api status
export const API_CALL_STATUS_LOADING = "loading";
export const UPLOAD_EXCEL_SUCCESS = "Upload Excel Success";
export const UPLOAD_EXCEL_FAIL = "Upload Excel Fail";

//Upload Excel color message
export const RED = "Data rejected: update not processed.";
export const YELLOW = "Data mismatch: update will be processed.";
export const BLACK = "Data correct: update will be processed.";

// Menu id
export const MENU_CONFIG = {
  "010000": {
    id: "010000",
    name: "Administration",
    defaultAccess: "View",
    subMenus: ["010100", "010200"],
  },
  "010100": {
    id: "010100",
    name: "User Management",
    accessMap: {
      View: [4, 5],
      "View and Edit": [1, 2, 4, 5],
      "Full access": [1, 2, 3, 4, 5],
    },
  },
  "010200": {
    id: "010200",
    name: "Roles and Permission",
    accessMap: {
      View: [9, 10],
      "View and Edit": [6, 7, 9, 10],
      "Full access": [6, 7, 8, 9, 10],
    },
  },

  "020000": {
    id: "020000",
    name: "Manage Resource",
    defaultAccess: "View",
    subMenus: ["020300", "020200"],
  },
  "020300": {
    id: "020300",
    name: "Home Page",
    accessMap: {
      View: [22],
      "Full access": [22, 23],
    },
  },
  "020200": {
    id: "020200",
    name: "Manage Product",
    accessMap: {
      "View and Edit": [17, 18, 19, 21],
      "Full access": [17, 18, 19, 20, 21],
    },
  },
};

// Label
export const LABEL_UPLOAD_FILE = "Upload File";
export const LABEL_DELETE_ASSET = "Are you sure you want to delete this file?";

// Error message
export const MESSAGE_ERROR_INPUT_REQUIRED = "Input required";

// Upload file type mapping
export const ASSET_TYPE_MAPPING = {
  package: "package",
  product: "product",
  homePage: "homePage"
};

export const ASSET_LOCATION_MAPPING = {
  iconUrl: {
    basicInfo: "basicInfo",
    specInfo: "specInfo",
    brands: "Brands"
  },
  bannerUrl: {
    basicInfo: "basicInfo"
  },
  campaignImageFileId: "Campaign",
  imageUrl: "Hardware",
  logo: "customerStories",
  mediaUrl: "Capabilities",
  videoIntroduction: "basicInfo",
};

export const FILE_FIELD_MAPPING = {
  iconUrl: ['iconUrl', 'iconFileId'],
  bannerUrl: ['bannerUrl', 'bannerFileId'],
  videoIntroduction: ['videoIntroduction', 'videoFileId']
};

// Response status
export const STATUS_CODE_RESPONSE_OK = "200";

// Api state
export const API_STATE = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

// Language options
export const LANGUAGE_OPTIONS = [
  { id: "EN", label: "EN", value: "EN" },
  { id: "CN", label: "CN", value: "CN" },
];
export const LANGUAGE_DEFAULT_OPTION = "EN";

// Language options
export const FORM_TYPE = {
  CREATE: "CREATE",
  EDIT: "EDIT",
};

export const REGION = 'REGION'

export const DOMAIN = 'BUSINESS_DOMAIN'

export const REGION_SG = 'SG'
